import { render } from "./NotFoundView.vue?vue&type=template&id=2312d586"
const script = {}

import exportComponent from "/home/runner/work/server-status-list/server-status-list/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__